export const pubs = [
  {
    pubName: 'The Bricklayers',
    comments: [],
    userRating: 2,
    latitude: 51.49425,
    longitude: 0.08555,
    description: 'Victorian local that is a Spurs football fans\' mainstay, with beer garden and matchday barbecues',
    image: 'https://tottenham-summerhillroad.com/bricklayers_arms_dec2011.jpg',
  },
  {
    pubName: 'The Bill Nicholson Pub',
    comments: [],
    userRating: 3,
    latitude: 51.6057,
    longitude: 0.0616,
    description: 'Shows all home and away games.',
    image: 'https://whatpub-new.s3.eu-west-1.amazonaws.com/images/pubs/800x600%402x/NLD-5814-36881-bill-nicholson-tottenham.jpg',
  },
  {
    pubName: 'The Twelve Pins',
    comments: [],
    userRating: 3,
    latitude: 51.5652,
    longitude: -0.1050,
    description: 'An Irish bar that tends to get very busy indeed on match days, The Twelve Pins is the perfect location for your pre-match pint.',
    image: 'https://pubwiki.co.uk/Middlesex/FinsburyPark/FinsburyParkTavern.jpg',
  },
  {
    pubName: 'The Drayton Park',
    comments: [],
    userRating: 2,
    latitude: 51.5539,
    longitude: -0.1049,
    description: 'The pub of choice for away supporters, The Drayton Park offers exactly what you\'d expect of a pub on a match day: beer, non-alcoholic drinks and not much space to stand.',
    image: 'https://pubwiki.co.uk/LondonPubs/Islington/DraytonPark.jpg',
  },
  {
    pubName: 'The King\'s Arms',
    comments: [],
    userRating: 3,
    latitude: 51.4861,
    longitude: -0.1810,
    description: 'This pub offers good food, nice ales and a top atmosphere. Probably not one for boisterous fans, mind.',
    image: 'https://twitter.com/TheKingsArmsSW/header_photo',
  },
  {
    pubName: 'The Broadway Bar & Grill',
    comments: [],
    userRating: 3,
    latitude: 51.4802,
    longitude: -0.1957,
    description: 'Located right next to Fulham Broadway station, you can enjoy, as the name suggests, good food and drink here.',
    image: 'https://whatpub-new.s3.eu-west-1.amazonaws.com/images/pubs/800x600%402x/WLD-16337-126033-broadway-bar-grill-fulham.jpg',
  },
  {
    pubName: 'The Griffin',
    comments: [],
    userRating: 4,
    latitude: 51.4872,
    longitude: -0.3032,
    description: 'Friendly corner local in a quiet residential area; comfortable interior, outside seating and a small shaded patio beer garden.',
    image: 'https://www.griffinbrentford.co.uk/-/media/34a42bbdaa534679b9de2e9ad0faed2f.ashx?as=0',
  },
  {
    pubName: 'Express Tavern',
    comments: [],
    userRating: 3,
    latitude: 51.4891,
    longitude: -0.2879,
    description: 'Cask and keg beer is the order of the day, though, so it\'s definitely a place for people who like to sample different beers.',
    image: 'https://www.telegraph.co.uk/content/dam/food-and-drink/2016/09/28/tet_trans_NvBQzQNjv4BqA7N2CxnJWnYI3tCbVBgu9V-UxAzQBOWbRM9zStsHOzU.jpg',
  },
  {
    pubName: 'Coborn',
    comments: [],
    userRating: 3,
    latitude: 51.5269,
    longitude: -0.0301,
    description: 'Tasty food, decent ales and plenty of TVs dotted around the place to watch a bit of sport on.',
    image: 'https://static.designmynight.com/uploads/2017/11/The-Coborn-High-Resolution102-optimised.jpg',
  },
  {
    pubName: 'The Eleanor Arms',
    comments: [],
    userRating: 2,
    latitude: 51.5349,
    longitude: -0.0330,
    description: 'Bow is one of East London\'s most characterful areas and The Eleanor Arms is one of its most fun pubs.',
    image: 'https://pubwiki.co.uk/LondonPubs/Bow/EleanorArms.jpg',
  },
  {
    pubName: 'The Eight Bells',
    comments: [],
    userRating: 2,
    latitude: 51.4680,
    longitude: -0.2102,
    description: 'Not the biggest pub in London but it\'s near Putney station and serves food and good cask ales.',
    image: 'https://media-cdn.tripadvisor.com/media/photo-w/0d/0e/9c/40/the-eight-bells.jpg',
  },
  {
    pubName: 'The Golden Lion',
    comments: [],
    userRating: 4,
    latitude: 51.4699,
    longitude: -0.2101,
    description: 'The Golden Lion promises typical British pub grub like bangers and mash and fish and chips as well as sport shown on big screens.',
    image: 'https://media-cdn.tripadvisor.com/media/photo-w/17/05/4d/d9/garden.jpg',
  },
  {
    pubName: 'The World Turned Upside Down',
    comments: [],
    userRating: 3,
    latitude: 51.4290,
    longitude: -0.9688,
    description: 'This family friendly option is open for breakfast, serves an all day carvery and a great selection of drinks. They also have vegan options, and you can walk to the stadium in 20 minutes.',
    image: 'https://i2-prod.getreading.co.uk/incoming/article12871586.ece/ALTERNATES/s810/World-Turned-Upside-Down.jpg',
  },
  {
    pubName: 'Walkabout Reading',
    comments: [],
    userRating: 3,
    latitude: 51.4571,
    longitude: -0.9708,
    description: 'You can\'t go too far wrong with a Walkabout if you\'re looking for somewhere to find a bit of sport. They serve standard pub grub, good drink options and promise good banter all around.',
    image: 'https://3.bp.blogspot.com/-r6J42mjvuco/WZhCYSioy_I/AAAAAAAAkzQ/8dgeZGHtCzsKmiq4jopETRHVBOSB1yufgCLcBGAs/s1600/DSC_6369_20170804145048506.jpg',
  },
  {
    pubName: 'The Builder\'s Arms',
    comments: [],
    userRating: 2,
    latitude: 51.3794,
    longitude: -0.0859,
    description: 'This pub is family friendly and also welcomes dogs, though you\'re unlikely to be taking your dog if you\'re heading to the match.',
    image: 'https://www.buildersarmscroydon.co.uk/-/media/sites/microsites/b/the-builders-arms-_-p014/images/2017-new-images/exterior-and-surrounding-area/fullers-builders-arms-missing-6.ashx',
  },
  {
    pubName: 'The Spread Eagle',
    comments: [],
    userRating: 3,
    latitude: 51.3722,
    longitude: -0.1001,
    description: 'It\'s a Fuller\'s pub so you know what you\'re getting from it as it\'s in line with others in that chain.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/e/ee/The_Spreadeagle%2C_Croydon.jpg',
  },
  {
    pubName: 'Coach & Horses',
    comments: [],
    userRating: 3,
    latitude: 51.5610,
    longitude: -0.0102,
    description: 'The Coach & Horses is just a short walk from the ground and is a cosy, friendly pub with a welcoming atmosphere.',
    image: 'https://static.designmynight.com/uploads/2019/07/DSC7991-Edit_resized_20190121_043644063-optimised.jpg',
  },
  {
    pubName: 'Leyton Technical Pub',
    comments: [],
    userRating: 4,
    latitude: 51.5587,
    longitude: -0.0074,
    description: 'Located in the old town hall and just a short walk from Leyton Underground Station is this restored beauty of a pub that serves real ale and delicious food.',
    image: 'https://leytontechnical.com/wp-content/uploads/LeytonTechnical-72.jpg',
  },
  {
    pubName: 'The Plough',
    comments: [],
    userRating: 3,
    latitude: 51.5438,
    longitude: 0.6923,
    description: 'At The Plough you\'ll get all of the usual drinks that you\'d expect to find in a quality pub, something nice and tasty to eat and large screen TVs that will show the latest live sport.',
    image: 'https://ents24.imgix.net/image/000/297/258/a2ac8eea80f5e70baef1c0397823bc9306540384.jpg',
  },
  {
    pubName: 'The Trading Room',
    comments: [],
    userRating: 4,
    latitude: 51.5448,
    longitude: 0.6883,
    description: 'The Trading Room is a cracking little place that serves amazing food and standard drinks. There are also big screens that show the sport.',
    image: 'https://the-trading-room.eastangliapubs.com/images/EAPco-TR-HR-00029.jpg',
  },
  {
    pubName: 'The Wheelwrights Arms',
    comments: [],
    userRating: 3,
    latitude: 51.4105,
    longitude: -0.3018,
    description: 'This pub is all about attracting the sports crowd, with a number of TVs dotted around the place in order to show anything live at any given moment.',
    image: 'https://media-cdn.tripadvisor.com/media/photo-w/08/1b/12/6d/wheelwrights-best-sport.jpg',
  },
  {
    pubName: 'O\'Neill\'s',
    comments: [],
    userRating: 2,
    latitude: 51.4093,
    longitude: -0.3058,
    description: 'There\'s a cracking menu on offer here as well as decent drinks - Guinness is a nice tipple you may not have heard of - and loads of TVs for the old sport.',
    image: 'https://whatpub-new.s3.eu-west-1.amazonaws.com/images/pubs/800x600%402x/KIN-7029-99062-o-neills-kingston.jpg',
  },
  {
    pubName: 'Slug & Lettuce',
    comments: [],
    userRating: 2,
    latitude: 52.0380,
    longitude: -0.7641,
    description: 'The Slug & Lettuce is a chain pub that does food and standard drinks. They also show a range of live sports on the big screen.',
    image: 'https://whatpub-new.s3.eu-west-1.amazonaws.com/images/pubs/800x600%402x/BUN-1994-111329-slug-lettuce-the-hub-milton-keynes.jpg',
  },
  {
    pubName: 'MK11 Sports Bar',
    comments: [],
    userRating: 3,
    latitude: 52.0430,
    longitude: -0.8234,
    description: 'MK11 Sports Bar shows all sorts of live sports and they also do live music. There\'s good drinks on offer and a menu, too.',
    image: 'https://whatpub-new.s3.eu-west-1.amazonaws.com/images/pubs/800x600%402x/BUN-1933-61271-mk11-live-music-venue-sports-bar-milton-keynes.jpg',
  },
  {
    pubName: 'The Broadhall Suite',
    comments: [],
    userRating: 2,
    latitude: 51.8899,
    longitude: -0.1936,
    description: 'Located in the stadium itself is this area that is welcoming of both home and away supporters, it\'s used as one of the club\'s hospitality suites',
    image: 'https://d2d6nee8hswz6i.cloudfront.net/large_6330_jims6173.jpg',
  },
  {
    pubName: 'Our Mutual Friend',
    comments: [],
    userRating: 3,
    latitude: 51.8877,
    longitude: -0.1868,
    description: 'A pub with lots of outdoor space, a pool table, dart board, real ales and even live music.',
    image: 'http://images.cdn.inapub.co.uk/photos/d33cf27ddb004e2abbf293627037a0ad.jpg?width=1000&height=1000&mode=max',
  },
  {
    pubName: 'Fleur De Lis',
    comments: [],
    userRating: 4,
    latitude: 51.3832,
    longitude: 0.5492,
    description: 'It has two bars and is popular with away supporters so you should be able to enjoy a swift pint without any trouble.',
    image: 'http://www.dover-kent.com/2015-photos1/Fleur-De-Lis-1937-Gillingham.jpg',
  },
  {
    pubName: 'The Britannia',
    comments: [],
    userRating: 2,
    latitude: 51.3868,
    longitude: 0.5489,
    description: 'The Britannia was re-decorated recently and is just what you\'d expect from a pub near to a train station.',
    image: 'https://www.starpubs.co.uk/sites/default/files/Screen%20Shot%202018-10-25%20at%2018.00.28.png',
  },
  {
    pubName: 'The Red Lion',
    comments: [],
    userRating: 3,
    latitude: 51.6510,
    longitude: -0.4017,
    description: 'This is the closest pub to the ground so it\'s likely to be busy and full of atmosphere if you visit on match day.',
    image: 'https://pubwiki.co.uk/HertsPubs/Watford/RedLionVicarage.jpg',
  },
  {
    pubName: 'The Oddfellows Arms',
    comments: [],
    userRating: 3,
    latitude: 51.6522,
    longitude: -0.4006,
    description: 'The best pub for away fans, this place does good food and all of the drinks you\'d expect from a public house.',
    image: 'https://10619-2.s.cdn12.com/rests/original/801_77722149.jpg',
  }
  // {
  //   pubName: 'Rose of Denmark',
  //   comments: [],
  //   userRating: 3,
  //   latitude: 51.4872,
  //   longitude: 0.0267,
  //   description: 'This place is for home supporters only after the match, but it welcomes both sets of fans before kick-off. ',
  //   image: '',
  // },
  // {
  //   pubName: '',
  //   comments: [],
  //   userRating: ,
  //   latitude: ,
  //   longitude: ,
  //   description: '',
  //   image: '',
  // },
  // {
  //   pubName: '',
  //   comments: [],
  //   userRating: ,
  //   latitude: ,
  //   longitude: ,
  //   description: '',
  //   image: '',
  // },
  // {
  //   pubName: '',
  //   comments: [],
  //   userRating: ,
  //   latitude: ,
  //   longitude: ,
  //   description: '',
  //   image: '',
  // },
]